import React, { useState } from 'react';
import cn from 'classnames';
import { Button } from "../Button";
import { IconButton } from "../IconButton";
import { DropdownMenu } from "../DropdownMenu";
import { TableList, useTableListRowContext } from "../TableList";
import { MoreVertical } from "../../icons";
import styles from "./TableListActions.module.scss";
/**
 * Composite component used in tables as the last column that shows actions to be
 * performed on the row. Will only show itself when the row is hovered or when the
 * dropdown is opened.
 */
export function TableListActions(props) {
  const {
    buttonText,
    buttonIntent,
    secondaryButtonText,
    children,
    testId,
    btnHeapId,
    secondaryBtnHeapId,
    menuHeapId,
    onClickButton,
    onClickSecondaryButton
  } = props;
  const {
    setForceHover,
    size
  } = useTableListRowContext();
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.actionsWrapper, {
      [TableList.classes.showAlways]: isOpen
    }),
    onClick: e => {
      e.stopPropagation();
      e.preventDefault(); //to prevent full page navigation when wrapped in an "a" tag
    }
  }, (buttonText || secondaryButtonText) && /*#__PURE__*/React.createElement("div", {
    className: cn(styles.buttonsWrapper, TableList.classes.showOnRowHover, {
      [styles.withoutDropdown]: !children,
      [TableList.classes.showAlways]: isOpen
    })
  }, buttonText && /*#__PURE__*/React.createElement(Button, {
    noWrap: true,
    intent: buttonIntent,
    size: size !== 'large' ? 'small' : 'medium',
    onClick: onClickButton,
    "data-testid": testId && "".concat(testId, "-btn"),
    "data-heapid": btnHeapId
  }, buttonText), secondaryButtonText && /*#__PURE__*/React.createElement(Button, {
    noWrap: true,
    skin: "primaryOutline",
    className: styles.secondaryBtn,
    size: size !== 'large' ? 'small' : 'medium',
    onClick: onClickSecondaryButton,
    "data-testid": testId && "".concat(testId, "-secondary-btn"),
    "data-heapid": secondaryBtnHeapId
  }, secondaryButtonText)), children ? /*#__PURE__*/React.createElement(DropdownMenu, {
    onOpenChange: open => {
      setIsOpen(open);
      setForceHover(open);
    },
    onClose: (anchorEl, reason) => {
      if (reason === 'backdropClick') {
        // Manually blur the anchorEl to prevent it from staying visible on a non-hovered row.
        requestAnimationFrame(() => {
          anchorEl && anchorEl.blur();
        });
      }
    },
    target: /*#__PURE__*/React.createElement(IconButton, {
      "data-testid": testId && "".concat(testId, "-dropdown-trigger"),
      "data-heapid": menuHeapId
    }, /*#__PURE__*/React.createElement(MoreVertical, null)),
    "data-testid": "".concat(testId, "-dropdown")
  }, children) : /*#__PURE__*/React.createElement("div", {
    "data-testid": testId && "".concat(testId, "-dropdown-placeholder"),
    className: styles.hiddenDropdown
  }));
}